import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import PieChartComponent from '../../../../library/SimpleControls/PieChartControl';
import useRecruiterDashboard from './useRecruiterDashboard';

const PotentialRecruitersPie = () => {
    const { state } = useContext(SmartContext);
    const { getPotentialRecruitersPieData } = useRecruiterDashboard();

    useEffect(() => {
        getPotentialRecruitersPieData();
    }, [state.data.searchCriteria.potentialRecruitersPie]);

    if (isEmpty(state.data?.reportData?.potentialRecruitersPie)) 
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <PieChartComponent data={state.data.reportData.potentialRecruitersPie} />
        </>
    );
};

export default PotentialRecruitersPie;
